import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import moment from "moment";
import log from '../../../helpers/logger'
import { auth, getCurrentUser } from '../../../helpers/auth'
import { getTimeStamp, getUUIDV4 } from '../../../helpers/utils'
import { storageRef, firebaseStorageBookZipFolder } from '../../../config/constants'
import {
  createFile_book_download_url_list,
  updateFile_book_download_url_list,
  deleteFile_book_download_url_list,
  getFile_book_download_url_list,
  getFile_book_download_url_listListByIssue,
  removeFile_book_download_url_list,
  getFile_book_download_url_listList } from '../../../services/File_book_download_url_listService'

function setErrorMsg(error) {
  return {
    errorMsg: error.message
  }
}

export default class File_book_download_url_listPageListByIssue extends Component {

  constructor(props) {
    super(props);
    this.state = {
      errorMsg: null,
      currentUser: null,
      isLoading: true,
      dataList: []
    };
    this.goBack = this.goBack.bind(this);
    this.handleDelete = this.handleDelete.bind(this);
  }

  componentWillMount() {
    log.debug('componentWillMount')
  }
  async componentDidMount(){
    log.debug('componentDidMount')
    let user = await getCurrentUser();
    this.setState({currentUser: user})

    let dataList = await getFile_book_download_url_listListByIssue(this.props.match.params.issue_id);
    /*
    log.debug(dataList.length)
    dataList.forEach(function(doc) {
        log.debug(doc.id, " => ", doc.data());
    });
    */

    log.debug('all data is loaded.')
    this.setState({dataList: dataList})
    this.setState({isLoading: false})
  }

  goBack(){
      this.props.history.goBack();
  }

  handleDelete(id, filename, issue_id, e){
    e.preventDefault()
    var r = window.confirm("Confirm to delete.");
    if (r == true) {
        log.debug('do delete')
        // Create a reference to the file to delete
        var desertRef = storageRef.child(firebaseStorageBookZipFolder+'/'+filename);

        let self = this
        // Delete the file
        desertRef.delete().then(function() {
          // File deleted successfully
          log.debug("File deleted successfully");
          removeFile_book_download_url_list(id).then(function(){
            log.debug("delete in database successfully")
            self.relaodData()
          }).catch(function(error) {
            log.debug("Error removing document: ", error);
          });

        }).catch(function(error) {
          // Uh-oh, an error occurred!
          log.debug(error);
          log.debug(error.message);
          alert(error.message);
        });

    } else {
        log.debug('delete cancel')
    }
  }

  async relaodData(){
    let dataList = await getFile_book_download_url_listListByIssue(this.props.match.params.issue_id);
    this.setState({dataList: dataList})
  }

  render () {

    let content;

    if (this.state.isLoading) {
      content = <div>Loading...</div>;
    } else {
      content =
      <div>
          <h4 className="page-header">
          <button className="btn btn-success" onClick={this.goBack}>Go Back</button> ->
          List
        </h4>
          <table className="table">
              <thead>
                  <tr>
                      <th> file_book_download_url_list_id </th>

                      <th>file_url</th>
                      <th>filename</th>
                      {/* <th>issue_id</th> */}
                      <th>date_created</th>
                      <th> Actions </th>
                  </tr>
              </thead>
              <tbody>
                {
                  this.state.dataList.map((data, index) =>
                  <tr key={index}>
                    <td>{data.id}</td>

                      {/* <td>{data.data().file_url} </td> */}
                      <td><a target="_blank" href={data.data().file_url}>View</a> </td>
                      <td>{data.data().filename} </td>
                      {/* <td>{data.data().issue_id} </td> */}
                      {/* <td>{data.data().date_created} </td> */}
                      <td>{moment(data.data().date_created).fromNow()}</td>
                      <td>
                        <button
                          type="button"
                          onClick={(e) => this.handleDelete(data.id, data.data().filename, data.data().issue_id, e)}
                          className="btn btn-small btn-danger">Delete</button>
                      </td>
                  </tr>
                )
                }
              </tbody>
          </table>
          {/* <p>
              <Link className="btn btn-success" to='/file_book_download_url_list/add'>Add New File_book_download_url_list</Link>
          </p> */}
      </div>
    }


    return (
      <div>
          {content}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/pages/File_book_download_url_listPage/File_book_download_url_listPageListByIssue.js